import { getDialogueById } from '../../data/dialogues';

import { SCENE_KEYS } from '../../data/gameConstants';

import { Collectible } from '../../objects/Collectible';

import { NPC } from '../../objects/NPC';

import { SaveSystem } from '../../systems/SaveSystem';

import { ZoneCoreSystems } from '../../systems/ZoneCoreSystems';

import { ObjectiveHint } from '../../ui/ObjectiveHint';

import { SceneTransition } from '../../utils/SceneTransition';

import { Zone1Map, ZONE1_POSITIONS } from './Zone1Map';

import { ZONE2_POSITIONS } from '../zone2/Zone2Map';



export class Zone1QuestFlow {

  private core: ZoneCoreSystems;

  private map: Zone1Map;

  private kakek: NPC;

  private rafflesia: Collectible;

  private hint: ObjectiveHint;

  private forestExitX = ZONE1_POSITIONS.FOREST_EXIT.x - 60;

  private transitioning = false;



  constructor(

    core: ZoneCoreSystems,

    map: Zone1Map,

    kakek: NPC,

    rafflesia: Collectible,

    hint: ObjectiveHint,

  ) {

    this.core = core;

    this.map = map;

    this.kakek = kakek;

    this.rafflesia = rafflesia;

    this.hint = hint;

  }



  start(): void {

    this.kakek.setInteractEnabled(false);

    this.rafflesia.setUnlocked(false);



    const signDone = this.core.quest.getStatus('zone1_read_sign') === 'completed';

    const kakekDone = this.core.quest.getStatus('zone1_meet_kakek') === 'completed';

    let rafflesiaDone = this.core.quest.getStatus('zone1_collect_rafflesia') === 'completed';

    const forestDone = this.core.quest.getStatus('zone1_to_forest') === 'completed';



    if (this.rafflesia.isCollected() && !rafflesiaDone) {

      this.core.quest.completeQuest('zone1_collect_rafflesia');

      rafflesiaDone = true;

    }



    if (forestDone || rafflesiaDone) {

      this.openForestPath();

      this.core.quest.activateQuest('zone1_to_forest');

    }



    if (rafflesiaDone) {

      this.rafflesia.setUnlocked(false);

    } else if (kakekDone) {

      this.activateRafflesia();

    }



    if (kakekDone) {

      this.kakek.setInteractEnabled(true);

    } else if (signDone) {

      this.onSignCompleted();

    }



    if (!signDone) {

      this.core.showIntroDialogue('zone1_narrator', () => this.onNarratorComplete());

    } else if (!kakekDone) {

      this.hint.show('Baca Papan Petunjuk', ZONE1_POSITIONS.SIGN.x, ZONE1_POSITIONS.SIGN.y - 70);

    } else if (!rafflesiaDone) {

      this.hint.show('Ambil Rafflesia Point', ZONE1_POSITIONS.RAFFLESIA.x, ZONE1_POSITIONS.RAFFLESIA.y - 60);

    } else if (!forestDone) {

      this.hint.show('Menuju Jalur Hutan', ZONE1_POSITIONS.FOREST_EXIT.x, ZONE1_POSITIONS.FOREST_EXIT.y - 52);

    }

  }



  onSignInteract(): void {

    const status = this.core.quest.getStatus('zone1_read_sign');

    if (status === 'locked') return;



    const dialogue = getDialogueById('zone1_sign');

    if (!dialogue) return;



    if (status === 'completed') {

      this.core.dialogue.show(dialogue);

      return;

    }



    this.core.dialogue.show(dialogue, () => this.onSignCompleted());

  }



  onKakekInteract(): void {

    if (this.core.quest.getStatus('zone1_meet_kakek') === 'completed') {

      const dialogue = getDialogueById('zone1_kakek_sakti');

      if (dialogue) this.core.dialogue.show(dialogue);

      return;

    }



    if (this.core.quest.getStatus('zone1_read_sign') !== 'completed') return;



    const dialogue = getDialogueById('zone1_kakek_sakti');

    if (!dialogue) return;



    this.core.dialogue.show(dialogue, () => this.onKakekCompleted());

  }



  onRafflesiaCollected(): void {

    this.core.quest.completeQuest('zone1_collect_rafflesia');

    this.hint.hide();

    this.openForest();

  }



  checkForestExit(playerX: number): void {

    if (this.transitioning) return;

    if (this.core.quest.getStatus('zone1_collect_rafflesia') !== 'completed') return;



    if (this.core.quest.getStatus('zone1_to_forest') === 'locked') {

      this.core.quest.activateQuest('zone1_to_forest');

      this.openForestPath();

      this.hint.show('Menuju Jalur Hutan', ZONE1_POSITIONS.FOREST_EXIT.x, ZONE1_POSITIONS.FOREST_EXIT.y - 52);

    }



    if (playerX >= this.forestExitX) {

      this.transitionToZone2();

    }

  }



  checkForestBlocked(_playerX: number): void {

    // Blokir fisik saja — konsep tidak menyebut dialog peringatan di sini

  }



  private onNarratorComplete(): void {

    this.core.quest.activateQuest('zone1_read_sign');

    this.hint.show('Baca Papan Petunjuk', ZONE1_POSITIONS.SIGN.x, ZONE1_POSITIONS.SIGN.y - 70);

  }



  private onSignCompleted(): void {

    if (this.core.quest.getStatus('zone1_read_sign') !== 'completed') {

      this.core.quest.completeQuest('zone1_read_sign');

    }

    this.core.quest.activateQuest('zone1_meet_kakek');

    this.kakek.setInteractEnabled(true);

    this.hint.show('Temui Kakek Sakti', ZONE1_POSITIONS.KAKEK.x, ZONE1_POSITIONS.KAKEK.y - 70);

  }



  private onKakekCompleted(): void {

    this.core.quest.completeQuest('zone1_meet_kakek');

    this.activateRafflesia();

  }



  private activateRafflesia(): void {

    this.rafflesia.setUnlocked(true);

    this.core.quest.activateQuest('zone1_collect_rafflesia');

    this.hint.show('Ambil Rafflesia Point', ZONE1_POSITIONS.RAFFLESIA.x, ZONE1_POSITIONS.RAFFLESIA.y - 60);

  }



  private openForestPath(): void {

    this.map.openForestPath();

    this.core.removeObstacleNear(

      ZONE1_POSITIONS.FOREST_BLOCK.x,

      ZONE1_POSITIONS.FOREST_BLOCK.y,

    );

  }



  private openForest(): void {

    this.openForestPath();

    this.core.quest.activateQuest('zone1_to_forest');

    this.hint.show('Menuju Jalur Hutan', ZONE1_POSITIONS.FOREST_EXIT.x, ZONE1_POSITIONS.FOREST_EXIT.y - 52);

  }



  private transitionToZone2(): void {

    this.transitioning = true;

    this.core.quest.completeQuest('zone1_to_forest');

    this.core.quest.activateQuest('zone2_enter_forest');



    SaveSystem.save({

      currentScene: SCENE_KEYS.ZONE2,

      currentZone: 2,

      rafflesiaPoints: this.core.score.getScore(),

      playerX: ZONE2_POSITIONS.SPAWN.x,

      playerY: ZONE2_POSITIONS.SPAWN.y,

    });



    this.hint.hide();

    SceneTransition.fadeOutAndStart(this.core.scene, SCENE_KEYS.ZONE2, 400);

  }



  destroy(): void {

    this.hint.destroy();

  }

}

